import {
  createAsyncThunk,
  createEntityAdapter,
  createSlice,
} from "@reduxjs/toolkit";
import {
  createProductOffer,
  deleteProductOffer,
  getProductOffers,
  updateProductOffer,
} from "data/server_apis/commodityService";

const productOfferAdapter = createEntityAdapter({
  selectId: (productOffer) => productOffer.id,
});

export const getOffersForProductThunk = createAsyncThunk(
  "productOffers/getForProduct",
  async (id, { rejectWithValue }) => {
    try {
      return (await getProductOffers(id)).data;
    } catch (err) {
      const customError = {
        name: err.response?.status,
        message: err.response?.status === 400 ? err.response?.data : null,
      };
      // console.log("Error", customError);
      return rejectWithValue(customError);
    }
  }
);

export const createProductOfferThunk = createAsyncThunk(
  "productOffers/create",
  async (data, { rejectWithValue }) => {
    try {
      return (await createProductOffer(data)).data;
    } catch (err) {
      const customError = {
        name: err.response?.status,
        message: err.response?.status === 400 ? err.response?.data : null,
      };
      // console.log("Error", customError);
      return rejectWithValue(customError);
    }
  }
);

export const updateProductOfferThunk = createAsyncThunk(
  "productOffer/update",
  async ({ id, data }, { rejectWithValue }) => {
    try {
      return (await updateProductOffer(id, data)).data;
    } catch (err) {
      const customError = {
        name: err.response?.status,
        message: err.response?.status === 400 ? err.response?.data : null,
      };
      // console.log("Error", customError);
      return rejectWithValue(customError);
    }
  }
);

export const deleteProductOfferThunk = createAsyncThunk(
  "productOffer/delete",
  async (id, { rejectWithValue }) => {
    try {
      return (await deleteProductOffer(id)).data;
    } catch (err) {
      const customError = {
        name: err.response?.status,
        message: err.response?.status === 400 ? err.response?.data : null,
      };
      // console.log("Error", customError);
      return rejectWithValue(customError);
    }
  }
);

const productOffersSlice = createSlice({
  name: "productOffers",
  initialState: productOfferAdapter.getInitialState({
    loading: {},
    error: {},
    errorMessage: {},
    success: {},
  }),
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getOffersForProductThunk.pending, (state, action) => {
        state.loading = { get: action.meta.arg };
        state.error = {};
        state.errorMessage = {};
        state.success = {};
      })
      .addCase(getOffersForProductThunk.rejected, (state, action) => {
        state.loading = {};
        state.error = { get: action.meta.arg };
        state.errorMessage = { get: action.payload?.message };
        state.success = {};
      })
      .addCase(getOffersForProductThunk.fulfilled, (state, action) => {
        state.loading = {};
        state.error = {};
        state.errorMessage = {};
        state.success = { get: action.payload?.message };
        productOfferAdapter.setAll(state, action.payload);
      });

    builder
      .addCase(createProductOfferThunk.pending, (state, action) => {
        state.loading = { create: action.meta.arg.product };
        state.error = {};
        state.errorMessage = {};
        state.success = {};
      })
      .addCase(createProductOfferThunk.rejected, (state, action) => {
        state.loading = {};
        state.error = { create: action.meta.arg.product };
        state.errorMessage = { create: action.payload?.message };
        state.success = {};
      })
      .addCase(createProductOfferThunk.fulfilled, (state, action) => {
        state.loading = {};
        state.error = {};
        state.errorMessage = {};
        state.success = { create: action.meta.arg.product };
        productOfferAdapter.addOne(state, action.payload);
      });

    builder
      .addCase(updateProductOfferThunk.pending, (state, action) => {
        state.loading = { update: action.meta.arg };
        state.error = {};
        state.errorMessage = {};
        state.success = {};
      })
      .addCase(updateProductOfferThunk.rejected, (state, action) => {
        state.loading = {};
        state.error = { update: action.meta.arg.id };
        state.errorMessage = { update: action.payload?.message };
        state.success = {};
      })
      .addCase(updateProductOfferThunk.fulfilled, (state, action) => {
        state.loading = {};
        state.error = {};
        state.errorMessage = {};
        state.success = { update: action.payload?.message };
        productOfferAdapter.updateOne(state, {
          id: action.meta.arg.id,
          changes: action.payload,
        });
      });

    builder
      .addCase(deleteProductOfferThunk.pending, (state, action) => {
        state.loading = { delete: action.meta.arg };
        state.error = {};
        state.errorMessage = {};
        state.success = {};
      })
      .addCase(deleteProductOfferThunk.rejected, (state, action) => {
        state.loading = {};
        state.error = { delete: action.meta.arg };
        state.errorMessage = { delete: action.payload?.message };
        state.success = {};
      })
      .addCase(deleteProductOfferThunk.fulfilled, (state, action) => {
        state.loading = {};
        state.error = {};
        state.errorMessage = {};
        state.success = { delete: action.meta.arg };
        productOfferAdapter.removeOne(state, action.meta.arg);
      });
  },
});
export const productOfferSelector = productOfferAdapter.getSelectors(
  (state) => state.productOffer
);
export const {} = productOffersSlice.actions;

export default productOffersSlice.reducer;
